import request from "superagent"
import prefix from "superagent-prefix"

export default request
  .agent()
  .timeout({ response: 500000 })
  .use(prefix(process.env.REACT_APP_API_ROUTE))
